import shortUUID from 'short-uuid'

export const getId = () => {
  return shortUUID.generate()
}
